/**
 * @generated SignedSource<<ba905ce613bb8c09cba19e5106b89ede>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentLiveArticleLiveArticle$data = {
  readonly status: boolean | null;
  readonly " $fragmentType": "contentLiveArticleLiveArticle";
};
export type contentLiveArticleLiveArticle$key = {
  readonly " $data"?: contentLiveArticleLiveArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentLiveArticleLiveArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentLiveArticleLiveArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "LiveArticle",
  "abstractKey": null
};

(node as any).hash = "93c1d07c53696c294d400745873cbcff";

export default node;
